import { render, staticRenderFns } from "./PaginaNegozi.vue?vue&type=template&id=95211502&"
import script from "./PaginaNegozi.vue?vue&type=script&lang=js&"
export * from "./PaginaNegozi.vue?vue&type=script&lang=js&"
import style0 from "./PaginaNegozi.vue?vue&type=style&index=0&id=95211502&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports